<template>
  <button class="state__close" @click="closeStateDialog">
    <IconClose aria-label="Dialog schließen" />
  </button>
  <h2 class="state__title h5">In welchem Bundesland dürfen wir Sie begrüßen?</h2>
  <p class="state__subtitle">
    Bitte geben Sie das Bundesland bekannt, in welchem der Termin stattfinden soll. So können wir
    unsere Leistungen anpassen.
  </p>
  <div class="state__buttons">
    <button
      v-for="state in federalStates"
      :key="state.id"
      class="state__button"
      @click="handleStateSelection(state)"
    >
      {{ state.bezeichnung }}
      <IconChevronRight aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import IconChevronRight from '@/components/icons/IconChevronRight.vue'
import IconClose from '@/components/icons/IconClose.vue'
import { convertToSlug } from '@/utils/format.js'
import { mapGetters } from 'vuex'

export default {
  components: { IconClose, IconChevronRight },
  emits: ['closeStateDialog'],
  computed: {
    ...mapGetters(['federalStates']),
  },
  methods: {
    closeStateDialog() {
      this.$emit('closeStateDialog')
    },
    handleStateSelection(state) {
      this.$store.commit('setSelectedState', state)
      this.$store.commit('setActiveStep', 1)
      // from Home component to Booking component
      this.$router.push({
        name: 'Service',
        query: { bundesland: convertToSlug(state.bezeichnung) },
      })
    },
  },
}
</script>

<style lang="scss">
.state {
  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }

  #content &__title,
  &__title {
    font-weight: $font-weight-medium;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: $line-height;
  }

  &__subtitle {
    color: $color-text-secondary;
    margin-bottom: 24px;
  }

  &__buttons {
    display: grid;
    gap: 8px;

    @media (min-width: $breakpoint-mobile) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__button {
    display: flex;
    justify-content: space-between;
    border: 1px solid $color-grey-light;
    border-radius: 4px;
    cursor: pointer;
    padding: 12px 12px 12px 16px;

    &:hover {
      background-color: rgba($color-grey-light, 0.3);
    }
  }
}
</style>
